import { Component, computed, input, InputSignal } from '@angular/core';
import { LogoOrientation } from '../types/logo-orientation.enum';
import { LogoVariant } from '../types/logo-variant.enum';
import { LogoSize } from '../types/logo-size.enum';

@Component({
    selector: 'app-cargosprint-logo',
    imports: [],
    templateUrl: './cargosprint-logo.component.html',
    styleUrl: './cargosprint-logo.component.scss'
})
export class CargosprintLogoComponent {

    public variant: InputSignal<LogoVariant> = input<LogoVariant>(LogoVariant.COLOR);
    public orientation: InputSignal<LogoOrientation> = input<LogoOrientation>(LogoOrientation.HORIZONTAL);
    public size: InputSignal<LogoSize> = input<LogoSize>(LogoSize.CUSTOM);

    public readonly logoPath = computed(() =>
        `assets/img/logo-cargosprint-${this.variant()}-${this.orientation()}.svg`
    );

}
